import React, { useCallback, useMemo } from 'react';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import NotificationsNone from '@material-ui/icons/NotificationsNone';
import { Button } from '@this/shared/ui/inputs/button';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

export const ORGANIZATION_INFORMATIONS_SECTION_ID = 'organization-informations';

type Props = {
  show: boolean;
};

const OrganizationInformationNotice: React.FC<Props> = ({ show }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  const handleScrollToOrganizationInformations = useCallback(() => {
    document.getElementById(ORGANIZATION_INFORMATIONS_SECTION_ID)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Button
      color="sub"
      fullWidth
      onClick={handleScrollToOrganizationInformations}
      aria-label="社内通知へスクロール"
      style={styles.bar}
    >
      <span style={styles.label}>
        <NotificationsNone style={styles.icon} />
        社内通知をご確認ください
      </span>
      <ArrowDownward style={styles.icon} />
    </Button>
  );
};

function getStyles(theme: AITTheme) {
  const accent = theme.tokens.colors.danger.primary;
  return {
    bar: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: 0,
      boxShadow: 'none',
      border: 'none',
      borderLeft: `4px solid ${accent}`,
      padding: '16px',
      backgroundColor: theme.tokens.colors.common.white,
      color: theme.tokens.colors.text.primary,
      textTransform: 'none',
      textAlign: 'left',
      fontWeight: 700,
      fontSize: 13,
      lineHeight: 1
    } as const,
    label: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      color: theme.tokens.colors.text.primary
    } as const,
    icon: {
      fontSize: 20,
      color: accent
    } as const
  };
}

export default OrganizationInformationNotice;
